import styles from "./DashboardPositions.module.css"
import PositionCard from "../positionCard/PositionCard"
import { TempPositions } from "../../../data/positions"
const DashboardPositions = () => {


    const tempPositionsDisplay = (
        <div>
            {TempPositions.map((position) => (
                <PositionCard/>
            ))}
        </div>
    )
  return (
    <div>
    {TempPositions.map((position) => (
        <PositionCard posDetail={position.posDetail} key={ position.positionHash}/>
    ))}
</div>
  )
}

export default DashboardPositions